import { connect } from 'react-redux';
import { Translate } from 'react-redux-i18n';
import { LocalForm, Control, actions } from 'react-redux-form';

import { MANAGER, SUPPORT_ADMIN, SUPPORT } from 'app/constants';
import { isPresent } from 'app/validators';
import { createUser, updateUser } from 'app/action-creators';
import Users from 'endpoints/users';
import InputErrors from 'components/input-errors';
import BackLink from 'components/back-link';

import PermissionsField from './permissions-field'

class Form extends React.Component {
  constructor() {
    super();
    this.state = { role: null };

    this.onRoleChange = this.onRoleChange.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.onApiErrors = this.onApiErrors.bind(this);
  }

  componentWillReceiveProps(props) {
    if(this.props.id !== props.id) {
      this.setState({ role: null });
    }
  }

  isNew() {
    return this.props.id === 'new';
  }

  isCurrentUser() {
    // props.id is a string and currentUser.id is a number
    return this.props.id == this.props.currentUser.id;
  }

  onRoleChange(model, value) {
    this.formDispatch(actions.change(model, value));
    this.setState({ role: value });
  }

  onSubmit(form) {
    const isNewUser = this.isNew();
    const changes = { 
      name: form.name, 
      login: form.login,
      countries: this.props.serviceLocations.filter(item => item.selected).map(item => item.value),
      ...((!this.isCurrentUser()) && { role: form.role, permissions: form.permissions }),
      ...((form.password.trim() !== '') && { password: form.password.trim() }),
      ...([SUPPORT_ADMIN, SUPPORT].includes(form.role) && { permissions: [] })
    };

    if(isNewUser) {
      Users.create(changes).then(user => {
        this.props.createUser(user);
        this.props.history.push('/users');
      }, this.onApiErrors);
    } else {
      let id = parseInt(this.props.id);
      Users.update(id, changes).then(() => {
        this.props.updateUser(id, changes);
        this.props.history.push('/users');
      }, this.onApiErrors);
    }
  }

  onApiErrors(errors) {
    let validities = errors.reduce((acc, error) => {
      acc[error.key.toLowerCase()] = false;
      return acc;
    }, {});
    this.formDispatch(actions.setValidity('local.login', validities, { async: true }));
  }

  render() {
    const { user, roles } = this.props;
    const manager = roles.find(item => item.name === MANAGER) || '';
    const isNewUser = this.isNew();
    const isRoleSelectionDisabled = isNewUser ? false : (this.isCurrentUser() || user.role === SUPPORT_ADMIN);

    let initialState, passwordField, actionName;
    if(isNewUser) {
      initialState = { name: '', login: '', role: manager.name, password: '', permissions: [] };
      actionName = 'create';
      passwordField = (
        <div className="form-group form-group--required">
          <label><Translate value="attrs.password" /></label>
          <Control type="password" model=".password" className="form-control" validators={{ presence: isPresent }} />
          <InputErrors model=".password" messages={['presence']} />
        </div>
      );
    } else {
      let user = this.props.users.find(u => u.id == this.props.id);
      initialState = {
        name: user.name,
        login: user.login,
        role: user.role,
        password: '',
        permissions: user.permissions.map(p => ({ ...p }))
      };
      passwordField = (
        <div className="form-group">
          <label><Translate value="users.change_password" /></label>
          <Control type="password" model=".password" className="form-control" controlProps={{ placeholder: '******' }} disabled={isRoleSelectionDisabled} />
        </div>
      );
      actionName = 'update';
    }

    return (
      <LocalForm
        onSubmit={this.onSubmit}
        getDispatch={dispatch => this.formDispatch = dispatch}
        initialState={initialState}
      >
        <div className="page-title">
          <BackLink to="/users" className="page-title_back" />
          <h3><Translate value="users.title" /></h3>
          <BackLink to="/users" label="form.cancel" className="btn btn-secondary mr-2" />
          <button type="submit" className="btn btn-primary">
            <Translate value={`form.${actionName}`} />
          </button>
        </div>
        <div className="row">
          <div className="col-6">
            <div className="form-group form-group--required">
              <label><Translate value="attrs.role" /></label>
              <Control.select model=".role" className="form-control" changeAction={this.onRoleChange} disabled={isRoleSelectionDisabled}>
                {roles.map(r => <option key={r.name} value={r.name}>{r.name}</option>)}
              </Control.select>
            </div>
            <div className="form-group form-group--required">
              <label><Translate value="attrs.name" /></label>
              <Control type="text" model=".name" className="form-control" validators={{ presence: isPresent }} disabled={isRoleSelectionDisabled} />
              <InputErrors model=".name" messages={['presence']} />
            </div>
          </div>
          <div className="col-6">
            <div className="form-group form-group--required">
              <label><Translate value="attrs.login" /></label>
              <Control type="email" model=".login" className="form-control" validators={{ presence: isPresent }} disabled={isRoleSelectionDisabled} />
              <InputErrors model=".login" messages={['presence']} />
            </div>
            {passwordField}
          </div>
          <div className="col-12">
            <Control model=".permissions" component={PermissionsField} controlProps={{ role: this.state.role || initialState.role }} disabled={isRoleSelectionDisabled} />
          </div>
        </div>
      </LocalForm>
    )
  }
}

const mapStateToProps = state => {
  return {
    user: state.auth.user,
    roles: state.data.roles,
    serviceLocations: state.data.serviceLocations,
  }
}

export default connect(mapStateToProps, { createUser, updateUser })(Form);
